'use strict';

angular.module('app')
	.controller('AccActivationCtrl', function(Auth, $rootScope, gettextCatalog) {
        var vm = this;
        
        vm.form = {
            isTermsAccepted: false,
            toSubscribe: false
        }

        vm.activate = function(form) {
            if (form.$valid) {
                Auth.confirmTerms(vm.form).then(function(res){
                    $rootScope.showNotify(gettextCatalog.getString('You are successfully logged in'));
                })
                .catch(function(error) {
                    var err = _.map(error.data);

                    $rootScope.showNotify(err[0]);
                });
            }
        }

	}); 
